var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg8S(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 167 167",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:gray;}.cls-2{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m74.39,16.14L21.77,144.78c-.11.27-.21.54-.29.81-2.49,7.96,6.83,14.48,13.76,9.84l48.26-32.3,48.26,32.3c6.93,4.64,16.25-1.89,13.76-9.84-.08-.27-.18-.54-.29-.81L92.61,16.14c-3.34-8.16-14.89-8.16-18.22,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 167,
    height: 167
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg8S);
export default __webpack_public_path__ + "static/media/8-s.743443219a134808403e0fa165901266.svg";
export { ForwardRef as ReactComponent };